import {
  checkoutV202604,
  type operations,
} from "@fluid-app/checkout-api-client";
import { createPublicCheckoutApiClient } from "@/lib/checkout-api-client";

type StoreDropZoneResponse =
  operations["checkout_v2026_04_get_store_drop_zones"]["responses"][200]["content"]["application/json"];

type StoreDropZoneQuery =
  operations["checkout_v2026_04_get_store_drop_zones"]["parameters"]["query"];

export type DropZoneResponse = StoreDropZoneResponse;
export type DropZoneItem = DropZoneResponse["drop_zones"][number];
export type CheckoutZone = DropZoneItem["settings"]["zone"];
export type DropZonePage = DropZoneItem["settings"]["page"];

export async function fetchDropZones({
  fluidShop,
}: {
  fluidShop: string;
}): Promise<DropZoneResponse> {
  return checkoutV202604.checkout_v2026_04_get_store_drop_zones(
    createPublicCheckoutApiClient(),
    { fluid_shop: fluidShop } satisfies StoreDropZoneQuery,
  );
}
